export enum CountryCodeEnum {
    IRELAND = "IRL"
}